<!--新增工单模板-->
<template>
	<div class="addNewOwnerDialogBody">
		<el-dialog 
			:title="title" 
			:visible.sync="addTemplateShow"
			:close-on-click-modal="false">
			<div style="display: flex;width: 100%; height: 420px;">
				<div class="dialog-from">
					<el-form>
						<el-form-item label="流程名称" :label-width="formLabelWidth" :required="true">
							<el-input v-model="name" autocomplete="off" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="备注" :label-width="formLabelWidth">
							<textarea v-model="remark" style="width:100%; height:100px;resize:none;"></textarea>
						</el-form-item>
						<el-form-item label="设备" :label-width="formLabelWidth">
                            <div style="width:100%; min-height:100px;">
                                <font v-for="item in selectDeviceList" :key="item.no">{{item.label}}，</font>
                            </div>
						</el-form-item>
					</el-form>
				</div>
				<div class="dialog-device" style="height:300px;">
					<elCheckBoxTree ref="tree" @checkItem="checkItemList" :dataList='virtualDeviceList' style="height:400px;"></elCheckBoxTree>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addTemplateShow = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import elCheckBoxTree from '@/page/projectDingZhi/ningbo/elCheckBoxTree.vue'
	//借用ownerManagerStore，设备树用
	import ownerManagerStore from '@/page/system/meterReading/ownerManagerStore.js'
	export default {
		components: {
			elCheckBoxTree,
		},
		props: {
		},
		data() {
			return {
                id: -1,
                name: '',
                remark: '',
				formLabelWidth: '130px',
				addTemplateShow: false,
				title: '',
				deviceListName: '',
				selectDeviceList: [], //选中的设备
			}
		},
		created() {
		},
		mounted() {
		},
		destroyed() {},
		computed: {
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			bindedDeviceNos() {
				return ownerManagerStore.state.bindedDeviceNos
			},
			nowUnit() {
				return this.$store.unitStore.state.nowUnit
			}
		},
		watch: {
		},
		methods: {
			cleanTree(){
				this.$refs.tree.cleanTree();
			},
			checkItemList(list) {
				this.selectDeviceList = list.slice();
				for(var i=this.selectDeviceList.length-1; i>=0; i--){
					if(this.selectDeviceList[i]['type'] == 'group'){
						this.selectDeviceList.splice(i,1);
					}
				}
			},
			// 表单校验
			validForm() {
				var errorTips = "";
				if(this.name.length == 0){
					errorTips = '请填写名称';
                }
                if(this.selectDeviceList.length == 0){
                    errorTips = '请选择设备';
                }
				return errorTips;
			},
			confirm() {
				//非空处理
				let errorTips = this.validForm()
				if(errorTips != "") {
					this.$message({
						message: errorTips,
						type: 'warning'
					});
					return
				}

                var deviceNo = '';
                var deviceName = '';
                for(var i=0; i<this.selectDeviceList.length; i++){
                    if(this.selectDeviceList[i]['type'] == 'group'){
                        continue;
                    }
                    deviceNo += this.selectDeviceList[i].no + ',';
                    deviceName += this.selectDeviceList[i].label + ',';
                }
				if(this.id == -1){
					this.$api.ningboApi.newBelt(
						this.name, 
                        this.remark, 
                        deviceNo,
                        deviceName,
						respon => {
							this.$message({
								message: '保存成功',
								type: 'success'
							});
							this.$emit("saveSuccess")
							this.addTemplateShow = false
						}, failure => {
							this.$message({
								type: 'error',
								message: failure
							});
						}
					)
				}else{
					this.$api.ningboApi.updateBelt(
                        this.id,
						this.name, 
                        this.remark, 
                        deviceNo,
                        deviceName,
						respon => {
							this.$message({
								message: '保存成功',
								type: 'success'
							});
							this.$emit("saveSuccess")
							this.addTemplateShow = false
						}, failure => {
							this.$message({
								type: 'error',
								message: failure
							});
						}
					)
				}
			},
			setSelectedDeviceTree(selectedDev){
				var arr = selectedDev.split(',');
				
				
				
				var selectedArr = [];
				for(var i=0; i<arr.length; i++){
					for(var j=0; j<this.virtualDeviceList.length; j++){
						this.recurseDevTree(arr[i], this.virtualDeviceList[j], selectedArr)
					}
				}
				this.$refs.tree.setSelectedItems(selectedArr);
			},
			recurseDevTree(no, treeItem, arr){
				if(treeItem.no == no){
					arr.push(treeItem.pkid);
				}
				if(treeItem.children){
					for(var i=0; i<treeItem.children.length; i++){
						this.recurseDevTree(no, treeItem.children[i], arr);
					}
				}
			}
		}
	}
</script>

<style>
	.addNewOwnerDialogBody {
		/*width: 100%;
		 height: 100%;*/
	}
	
	.addNewOwnerDialogBody .dialog-from {
		width: calc(100% - 3.3rem);
		height: 100%;
	}
	
	.dialog-device {
		height: 710px;
		margin-left: 40px;
	}
	
	.addNewOwnerDialogBody .el-dialog__body {
		display: flex;
		align-items: center;
		padding: 0;
	}
</style>